module.exports = __webpack_public_path__ + "img/pic01.093d70c0.jpg";